<template>
  <b-container>
    <br />

    <b-card bg-variant="light">
      <h6>
        Desde aquí puede dar de alta un siniestro a nuestro departamento,
        adjuntando ficheros si es necesario
      </h6>
      <hr />

      <b-container class="bv-example-row">
        <b-row>
          <b-col cols="12" md="6">
            ¿A qué responsable de siniestros quiere dirigir esta comunicación?
            <br /><EmployeeList v-model="destino"></EmployeeList>
            <br />
          </b-col>
          <b-col cols="12" md="6"
            >Fecha del siniestro <br />
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-form-input
                id="fecha"
                name="fecha"
                v-model="fecha"
                placeholder="Fecha del siniestro"
                type="date"
              ></b-form-input> </b-input-group
          ></b-col>
        </b-row>
        <b-row>
          <br />
          <hr />
          <h5>Datos de contacto para este siniestro</h5>
        </b-row>
        <b-row>
          <b-col cols="12" md="6"
            ><b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-form-input
                id="nombre"
                name="nombre"
                v-model="nombre"
                placeholder="Nombre y apellidos"
              ></b-form-input> </b-input-group
          ></b-col>
          <b-col cols="12" md="6"
            ><b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-form-input
                id="telefono"
                name="telefono"
                v-model="telefono"
                placeholder="Teléfono de contacto"
              ></b-form-input> </b-input-group
          ></b-col>
        </b-row>
        <hr />
        <b-row>
          <h5>Mensaje</h5>
          <b-form-textarea
            id="textarea"
            v-model="text"
            placeholder="Escriba un mensaje de al menos 10 caracteres...IMPORTANTE: incluir el nombre y telefono del resto de contactos (si los hay) de este siniestro."
            :state="text.length >= 10"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-row>
      </b-container>
    </b-card>

    <br />
    <b-card bg-variant="light">
      <h6>Listado de ficheros adjuntos:</h6>
      <hr />
      <b-form-file v-model="selFile" ref="form" placeholder="" />

      <b-button size="sm" variant="outline-primary" @click="submitFile()">
        Adjuntar fichero &nbsp; &nbsp;<i class="fa fa-paperclip"></i
      ></b-button>
      <hr />

      <b-table striped hover :items="sentFiles">
        <template v-slot:cell(opciones)="data">
          <b-button
            size="sm"
            @click="deleteFile(data.item.file_uuid)"
            class="mr-1"
            variant="danger"
          >
            Eliminar
          </b-button>
        </template>
      </b-table>
    </b-card>
    <b-button v-if="!enviado" variant="success" @click="submitMessage()">
      Enviar ahora &nbsp; &nbsp;<i
        class="fa fa-floppy-o"
        aria-hidden="true"
      ></i>
    </b-button>
  </b-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import filetypeCellRenderer from "@/_services/api/filetypeCellRenderer.js"; // uploaded file type validator
import { insuranceClaimsService } from "@/_services/api/insuranceClaim.js"; // uploaded file type validator
import { mapState } from "vuex";
import { sizeFormatter, dateFormatter } from "@/_services/api/utils"; // Ag-grid display format for file size and date
import EmployeeList from "@/components/Siniestros/GestionFicheros/EmployeeList.vue";
export default {
  props: ["claim"],
  data() {
    return {
      destino: "",
      remitente: null,
      selFile: null,
      columnDefs: null,
      autoGroupColumnDef: null,
      frameworkComponents: null,
      rowSelection: null,
      gridOptions: {},
      modal: false,
      mShow: false,
      result_id: null,
      status: false,
      selectedDataSizes: [],
      selectedDataTotal: 0,
      text: "",
      nombre: "",
      telefono: "",
      fecha: "",
      sentFiles: [],
      enviado: false,
    };
  },
  components: {
    AgGridVue,
    EmployeeList,
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Name",
        field: "name",
        width: 300,
        filterParams: { newRowsAction: "keep" },
        checkboxSelection: (params) => {
          return params.columnApi.getRowGroupColumns().length === 0;
        },
        headerCheckboxSelection: function (params) {
          return params.columnApi.getRowGroupColumns().length === 0;
        },
      },
      {
        headerName: "Filetype",
        field: "filetype",
        width: 55,
        cellRenderer: "filetypeCellRenderer",
        filterParams: { newRowsAction: "keep" },
      },
      {
        headerName: "Size",
        field: "size",
        valueFormatter: sizeFormatter,
        width: 55,
        filterParams: { newRowsAction: "keep" },
      },
      {
        headerName: "Added",
        field: "since_added",
        width: 90,
        sort: "desc",
        valueFormatter: dateFormatter,
      },
    ];
    this.frameworkComponents = {
      filetypeCellRenderer: filetypeCellRenderer,
    };
    this.autoGroupColumnDef = {
      headerName: "Group",
      width: 250,
      field: "name",
      valueGetter: (params) => {
        if (params.node.group) {
          return params.node.key;
        } else {
          return params.data[params.colDef.field];
        }
      },
      headerCheckboxSelection: true,
      cellRenderer: "agGroupCellRenderer",
      cellRendererParams: { checkbox: true },
    };
    this.rowSelection = "multiple";
  },
  mounted() {
    //this.$store.dispatch('loadFiles')
    this.gridOApi = this.gridOptions.api;
  },
  computed: {
    ...mapState(["rowData"]),
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      params.api.sizeColumnsToFit();
      params.api.setRowData();
    },
    onRowSelected(event) {
      const selectedNodes = this.gridApi.getSelectedNodes();
      const selectedData = selectedNodes.map((node) => node.data);
      const selectedDataStringPresentation = selectedData
        .map((node) => node.name + " " + node.file_id)
        .join(", ");
      this.selectedDataSizes = selectedData.map((node) => node.size);
      // get the total size
      const add = (a, b) => a + b;
      if (this.selectedDataSizes.length > 0) {
        this.status = true;
        const totalSize = { value: this.selectedDataSizes.reduce(add) };
        this.selectedDataTotal = sizeFormatter(totalSize);
      } else {
        this.status = false;
      }
    },
    async submitFile() {
      if (this.selFile.size < 5 * 1024 * 1024) {
        var vm = this;
        const fd = new FormData();
        fd.append("file", vm.selFile);
        fd.append(
          "description",
          `Siniestro nuevo para la póliza ${this.claim.numero_poliza} (${this.claim.compania}) del cliente ${this.claim.cliente}`
        );
        var newFile = await insuranceClaimsService.submitFile(fd);

        this.sentFiles.push({
          file: newFile.file,
          file_uuid: newFile.file_uuid,
          description: newFile.description,
          timestamp: newFile.timestamp,
          opciones: "",
        });
      } else {
        alert("El archivo es demasiado grande");
      }
    },
    async submitMessage() {
      const fd = new FormData();
      this.remitente = localStorage.getItem("userInfo");
      let info = {
        isActive: false,
        claim_id: "N/A",
        claim_company_reference: this.claim.compania,
        policy_company_id: this.claim.numero_poliza,
        cli_business_name: this.claim.cliente,
        policy_company_business_name: this.claim.compania,
        line_of_insurance_description: "N/A",
        claim_start_date: "01/01/1753",
        claim_end_date: "01/01/1753",
        last_update_date: "01/01/1753",
        last_update_subject: "01/01/1753",
        description: "N/A",
        _rowVariant: "N/A",
      };
      var mensaje = `
      Fecha de siniestro: ${this.fecha}
      Nombre: ${this.nombre}
      Teléfono de contacto: ${this.telefono}
      Mensaje:
      ${this.text}
      `;
      fd.append("destino", this.destino);
      fd.append("mensaje", mensaje);
      fd.append("info", JSON.stringify(info));
      fd.append(
        "asunto",
        `Siniestro nuevo para la póliza ${this.claim.numero_poliza} (${this.claim.compania}) del cliente ${this.claim.cliente}`
      );
      fd.append("remitente", JSON.stringify(this.remitente));
      fd.append("archivos", JSON.stringify(this.sentFiles));
      var newFile = await insuranceClaimsService.submitMail(fd);
      alert("Mensaje enviado");
      this.enviado = true;
      this.$root.$emit("bv::hide::modal", "file-manager", "#btnShow");
    },
    async deleteFile(file_uuid) {
      var file = await insuranceClaimsService.deleteFile(file_uuid);
      this.sentFiles = this.sentFiles.filter(function (obj) {
        return obj.file_uuid !== file_uuid;
      });
    },
    handleOk() {
      this.$store.dispatch("deleteFile", this.result_id);
      this.mShow = false;
      this.status = false;
    },
    onRowClicked(event) {
      let file_id = event.node.data.file_id;
      let filename = event.node.data.name;
      this.$store.dispatch("downloadFile", filename);
    },
  },
};
</script>

<style lang="scss">
@import "~ag-grid-community/dist/styles/ag-theme-alpine.css";
.ag-theme-material {
  font-size: 16px !important;
}
.ag-theme-material .ag-row,
.ag-theme-material .ag-row:not(.ag-row-first) {
  padding-top: 7px !important;
}
.ag-cell-focus,
.ag-cell-no-focus {
  border: none !important;
}
.ag-root-wrapper-body.ag-layout-normal {
  border-radius: 4px !important;
}
/* Style buttons */
.btn {
  margin-top: 20px;
  border: none; /* Remove borders */
  color: white; /* White text */
  padding: 12px 16px; /* Some padding */
  font-size: 16px; /* Set a font size */
  cursor: pointer; /* Mouse pointer on hover */
}
/* Darker background on mouse-over */
.btn:hover {
  background-color: Gray;
}
.form-control {
  background-color: #fff !important;
}

.bg-light {
  background-color: #fff !important;
}
</style>
